import { R500 } from '@atlaskit/theme/colors';
import { extractorPriorityMap } from '../icon/priority';
export var extractTitleTextColor = function extractTitleTextColor(jsonLd) {
  var type = jsonLd['@type'];
  if (Array.isArray(type)) {
    var highestPriorityType = type.sort(function (a, b) {
      return extractorPriorityMap[b] - extractorPriorityMap[a];
    })[0];
    switch (highestPriorityType) {
      case 'atlassian:UndefinedLink':
        return "var(--ds-text-danger, ".concat(R500, ")");
      default:
        return undefined;
    }
  }
};